import { LG } from "./liquidGlass";

export const PAGINATION_STYLES = {
    "& .MuiPagination-ul": { gap: 1 },

    "& .MuiPaginationItem-root": {
        fontWeight: 500,
        fontSize: "0.8rem",
        height: 36,
        minWidth: 36,
        padding: "0 10px",
        borderRadius: LG.radius.pill,
        background: LG.color.surface,
        backdropFilter: LG.blurLight,
        WebkitBackdropFilter: LG.blurLight,
        border: `1px solid ${LG.color.border}`,
        color: LG.color.text,
        transition: LG.transition,

        "&:hover": {
            background: LG.color.surfaceHover,
            border: `1px solid ${LG.color.borderStrong}`,
        },

        "&.Mui-selected": {
            background: LG.color.buttonDark,
            color: LG.color.buttonDarkText,
            border: `1px solid ${LG.color.buttonDark}`,
            "&:hover": { background: "#000" },
        },

        "&.Mui-disabled": { opacity: 0.45 },
    },

    "& .MuiPaginationItem-ellipsis": {
        color: LG.color.textSecondary,
        height: 36,
        minWidth: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
} as const;

export const PAGE_SIZE_SELECT_STYLES = {
    formControl: {
        minWidth: 120,

        "& .MuiInputLabel-root": {
            fontSize: "0.7rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: LG.color.textSecondary,
        },

        "& .MuiOutlinedInput-root": {
            height: "36px",
            borderRadius: LG.radius.xs,
            background: LG.color.surface,
            backdropFilter: LG.blurLight,
            WebkitBackdropFilter: LG.blurLight,
            border: `1px solid ${LG.color.border}`,
            color: LG.color.text,

            "& .MuiOutlinedInput-notchedOutline": { border: "none" },

            "& .MuiSelect-select": {
                fontSize: "0.75rem",
                fontWeight: 600,
                textTransform: "uppercase",
                padding: "6px 34px 6px 12px",
                lineHeight: 1.2,
                color: "inherit",
            },

            "& .MuiSvgIcon-root": { color: "inherit" },
            "&:hover": { border: `1px solid ${LG.color.borderStrong}` },
        },
    },

    menuPaper: {
        borderRadius: LG.radius.sm,
        border: `1px solid ${LG.color.border}`,
        background: LG.color.surfaceStrong,
        backdropFilter: LG.blurStrong,
        mt: 0.5,
    },

    menuList: { py: 0.5 },

    menuItem: {
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "uppercase" as const,
        color: LG.color.text,
        minHeight: 40,
        borderRadius: LG.radius.xs,
        mx: 0.5,

        "&:hover": { background: LG.color.surface },

        "&.Mui-selected": {
            background: LG.color.buttonDark,
            color: LG.color.buttonDarkText,
        },
        "&.Mui-selected:hover": {
            background: "#000",
            color: LG.color.buttonDarkText,
        },
    },
} as const;
